<template>
  <div class="contact-float">
    <!-- 切换翻译 -->
    <div class="float-item">
      <div
        class="language"
        @click="changeLanguage($i18n.locale === 'en' ? 'zh' : 'en')"
      >
        {{ $i18n.locale === "en" ? "中" : "EN" }}
      </div>
    </div>

    <div
      class="float-item"
      @mouseenter="showPhone = true"
      @mouseleave="showPhone = false"
    >
      <el-icon><Phone /></el-icon>
      <div class="popup" v-show="showPhone">
        <p>电话：400 875 1331</p>
      </div>
    </div>

    <!-- 企业微信 -->
    <div
      class="float-item"
      @mouseenter="showQR = true"
      @mouseleave="showQR = false"
    >
      <el-icon><User /></el-icon>
      <div class="popup qr-popup" v-show="showQR">
        <img src="@/assets/qcode.jpg" alt="企业微信二维码" />
      </div>
    </div>

    <!-- 微信公众号 -->
    <div
      class="float-item"
      @mouseenter="showGzh = true"
      @mouseleave="showGzh = false"
    >
      <el-icon><ChatRound /></el-icon>
      <div class="popup qr-popup" v-show="showGzh">
        <img src="@/assets/qcoder.jpg" alt="公众号" />
      </div>
    </div>

    <!-- 返回顶部 -->
    <div class="float-item" @click="scrollToTop" v-show="showScrollTop">
      <el-icon><Top /></el-icon>
    </div>
  </div>
</template>

<script>
import { Phone, User, Top, ChatRound } from "@element-plus/icons-vue";

export default {
  name: "ContactFloat",
  components: { Phone, User, Top, ChatRound },
  data() {
    return {
      showPhone: false,
      showQR: false,
      showScrollTop: false,
      showGzh: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    handleScroll() {
      this.showScrollTop = window.scrollY > 3.5;
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;
   
    },
  },
};
</script>

<style scoped>
.contact-float {
  position: fixed;
  right: 2vw;
  bottom: 10vw;
  z-index: 999;
  display: flex;
  flex-direction: column;
  gap: 1.5vw;
}

.float-item {
  width: 2.5vw;
  height: 2.5vw;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 0.2vw 1.2vw rgba(0, 0, 0, 0.15);
  position: relative;
}

.float-item i {
  font-size: 1vw;
  color: #666;
}

.float-item:hover {
  background-color: #f5f5f5;
}

.popup {
  position: absolute;
  right: 6vw;
  top: 50%;
  transform: translateY(-50%);
  background-color: #fff;
  padding: 0.5vw;
  border-radius: 0.4vw;
  box-shadow: 0 0.2vw 1.2vw rgba(0, 0, 0, 0.15);
  white-space: nowrap;
}

.qr-popup img {
  width: 8vw;
  height: 8vw;
}

@media screen and (max-width: 940px) {
  .contact-float {
    position: fixed;
    right: 2vw;
    bottom: 25rem;
    z-index: 999;
    display: flex;
    flex-direction: column;
    gap: 1.5vw;
  }

  .float-item {
    width: 1.5rem;
    height: 1.5rem;
    background-color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 0.2vw 1.2vw rgba(0, 0, 0, 0.15);
    position: relative;
  }

  .float-item i {
    font-size: 1vw;
    color: #666;
  }

  .float-item:hover {
    background-color: #f5f5f5;
  }

  .popup {
    position: absolute;
    right: 6vw;
    top: 50%;
    transform: translateY(-50%);
    background-color: #fff;
    padding: 0.5vw;
    border-radius: 0.4vw;
    box-shadow: 0 0.2vw 1.2vw rgba(0, 0, 0, 0.15);
    white-space: nowrap;
  }

  .popup p {
    font-size: 0.6rem;
  }

  .float-item .el-icon {
    font-size: 0.8rem; /* 或者 60% 也可以根据需要微调 */
  }

  .qr-popup img {
    width: 5rem;
    height: 5rem;
  }
  .language {
    width: 100%;
    height: 100%;
    font-size: 0.6rem;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .float-item:last-of-type {
    display: none;
  }

  .language{
    border: 0px solid ;
  }
}

@media screen and (min-width: 941px) {
  .float-item:first-of-type {
    display: none;
  }
}
</style>